/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
      setTimeout(function(){
                  
        
                  var productJsonElement = document.querySelector('[data-product-json]'); // If we are using placeholder, there is no JSON so we wrap here!
                
                if (productJsonElement) {
                  var jsonData = JSON.parse(productJsonElement.innerHTML);
                  var freeprice = parseFloat(jsonData['freeshipping']);
                  var productPrice = document.querySelector(".product-price-container .amount").innerText.replaceAll(' ', '');
                  // var productLabel = document.querySelector(".product-form__info-item .price span").innerText.replaceAll(' ', '');                    
                  
                  // if(productLabel) {
                  //   productPrice = productPrice.replace(productLabel, '').trim();
                    
                  //    productPrice = parseFloat(productPrice.slice(1));
                  //   console.log(productPrice, "productPrice");
                  // }else {
                  //   productPrice = parseFloat(productPrice.slice(1))/100;
                  // }
                  productPrice = parseFloat(productPrice.slice(1));
                  
                  
                  
                   if (document.querySelector('#cart-total-price')) {
                     var cartTotal = parseFloat(document.querySelector('#cart-total-price').innerHTML) / 100;
                   }else {
                    var cartTotal = 0;
                  }
                  
                   if (cartTotal >= freeprice) {
                     document.querySelector("#shipping-text").innerHTML = "With free delivery";
                   }else {
                      if(productPrice >= freeprice ) {
                        document.querySelector("#shipping-text").innerHTML = "With free delivery";
                     } else {
                        if(productPrice + cartTotal >= freeprice) {
                          document.querySelector("#shipping-text").innerHTML = "With free delivery";
                        } else {
                          
                          let min = freeprice - cartTotal - productPrice;
                          var format = window.theme.settings.money_with_currency_format || "${{amount}}";                            
                          document.querySelector("#shipping-text").innerHTML = "Spend " + formatMoney(min * 100, format) + " more for free delivery";
                        }
                      }
                   }
                }
                 
               }, 1500)
    }
    
  }
  customElements.define('free-shipping', FreeShipping);
}